import Vue from "vue";
import { CARTCOUNT } from "./mutations-type";
import { setStore, getStore } from "@/until/utils";
export default {
  [CARTCOUNT](state, data) {
    // Vue.set(state, 'cart_count', data)
    state.cart_count = data;
    setStore("cart_count", state.cart_count);
  },
};



// WEBPACK FOOTER //
// ./src/store/mutations.js